import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (
  userId: 'me' | number,
  docUUID: string,
) =>
  makeCall<undefined>(
    'DELETE',
    `${APIV2_URL}/user/${userId}/document/${docUUID}`,
  );
